var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'underscore', 'backbone', 'core', 'model/document', 'model/file', 'app-common/component/loader', 'template/viewer.htm', 'common/lib/jquery.mousewheel', 'common/lib/jquery.smoothZoom'], function($, _, Backbone, core, DocumentModel, FileModel, loader, viewerTemplate) {
  var DocumentViewer;
  return DocumentViewer = (function(_super) {

    __extends(DocumentViewer, _super);

    function DocumentViewer() {
      DocumentViewer.__super__.constructor.apply(this, arguments);
    }

    DocumentViewer.prototype.el = function() {
      $('body').append('<div id="document-viewer"></div>');
      return $('#document-viewer')[0];
    };

    DocumentViewer.prototype.template = viewerTemplate;

    DocumentViewer.prototype.fullscreen = true;

    DocumentViewer.prototype.events = {
      'click .close': 'close',
      'click .next': 'next',
      'click .prev': 'prev',
      'mousedown .zoomin': 'zoomIn',
      'mousedown .zoomout': 'zoomOut',
      'click .download': 'download'
    };

    DocumentViewer.prototype.codes = {
      esc: 27
    };

    DocumentViewer.prototype.initialize = function(options) {
      var document,
        _this = this;
      if (options == null) {
        options = {};
      }
      if (_.isObject(options.document)) {
        return this.render(options.document, options.page);
      } else if (options.document) {
        document = new DocumentModel({
          id: options.document
        });
        document.init();
        loader.init({
          wide: true
        });
        document.once('init', function() {
          loader.hide();
          return _this.render(document, options.page);
        });
        return document.once('init.error', function() {
          return loader.hide();
        });
      }
    };

    DocumentViewer.prototype.getImages = function() {
      if (this.model.get('file') != null) {
        return this.model.get('file').getAllPagesByType('original');
      } else {
        return [];
      }
    };

    DocumentViewer.prototype.render = function(model, page) {
      var images,
        _this = this;
      this.model = model;
      if (page == null) {
        page = 0;
      }
      images = this.getImages();
      if (images.length === 0 || !images[page]) {
        return;
      }
      this.page = page;
      if (this.fullscreen) {
        $('body').addClass('no-scroll');
      }
      this.$el.show();
      this.$el.html(this.template);
      this.updatePage(this.page + 1, images.length);
      this.$el.find('.viewer').smoothZoom({
        width: this.$el.width(),
        height: '100%',
        initial_ZOOM: 80,
        zoom_MIN: 30,
        image_url: images[this.page],
        background_COLOR: 'transparent',
        border_SIZE: 0,
        animation_SMOOTHNESS: 1,
        animation_SPEED_ZOOM: 8,
        reset_TO_ZOOM_MIN: false,
        pan_BUTTONS_SHOW: false,
        zoom_BUTTONS_SHOW: false,
        on_ZOOM_PAN_UPDATE: function(data) {
          return _this.updateStats(data);
        }
      });
      this.setupShortCuts();
      return this.onRenderFinish();
    };

    DocumentViewer.prototype.onRenderFinish = function() {};

    DocumentViewer.prototype.close = function() {
      var _this = this;
      return this.$el.fadeOut(400, function() {
        _this.$el.find('.viewer').smoothZoom('destroy');
        return _this.remove();
      });
    };

    DocumentViewer.prototype.next = function() {
      return this.render(this.model, this.page + 1);
    };

    DocumentViewer.prototype.prev = function() {
      return this.render(this.model, this.page - 1);
    };

    DocumentViewer.prototype.zoomIn = function() {
      return this.$el.find('.viewer').smoothZoom('zoomIn');
    };

    DocumentViewer.prototype.zoomOut = function() {
      return this.$el.find('.viewer').smoothZoom('zoomOut');
    };

    DocumentViewer.prototype.updatePage = function(current, all) {
      return this.$el.find('.paginate').text("" + current + "/" + all);
    };

    DocumentViewer.prototype.updateStats = function(data) {
      return this.$el.find('.percentage').text(Math.round(data.ratio * 100) + '%');
    };

    DocumentViewer.prototype.download = function() {
      var _ref, _ref1;
      if (this.model && this.model.get('documentType') === 'STATEMENT' && core.isCurrentClientBookkeeper()) {
        return (_ref = this.model.get('file')) != null ? _ref.downloadAsStatement(this.model.get('id')) : void 0;
      } else {
        return (_ref1 = this.model.get('file')) != null ? _ref1.download() : void 0;
      }
    };

    DocumentViewer.prototype.setupShortCuts = function() {
      var _this = this;
      $(window).off('keydown.viewer');
      return $(window).on('keydown.viewer', function(e) {
        var code;
        code = e.which || e.keyCode;
        if (code === _this.codes.esc) {
          return _this.close();
        }
      });
    };

    DocumentViewer.prototype.remove = function() {
      DocumentViewer.__super__.remove.apply(this, arguments);
      if (this.fullscreen) {
        $('body').removeClass('no-scroll');
      }
      return $(window).off('keydown.viewer');
    };

    return DocumentViewer;

  })(Backbone.View);
});
